import {
  Heading,
  Box,
  AspectRatio,
  Image,
  Skeleton,
  SkeletonOptions,
  useTheme,
  HTMLChakraProps,
  SkeletonText,
} from '@chakra-ui/react';
import { FC } from 'react';

interface ICaseStudyHeaderProps extends HTMLChakraProps<'div'> {
  title: string;
  featuredImage?: string;
}

export const CaseStudyHeader: FC<ICaseStudyHeaderProps> = ({ title, featuredImage, ...rest }) => {
  const theme = useTheme();
  const { bleed } = theme.components.Container;

  return (
    <Box {...rest}>
      <Heading
        mt={[8, null, 10, 16]}
        mb={[10, null, 12, 20]}
        fontSize={['2.25rem', null, '3rem', '3.75rem']}
        lineHeight={['2.75rem', null, '3.75rem', '4.5rem']}
        mx="auto"
        maxW={[null, null, null, '794px']}
        textAlign="center"
      >
        {title}
      </Heading>

      <Box mx={[`-${bleed.sm}`, null, null, 'auto']} maxW={[null, null, null, '1000px']}>
        <AspectRatio maxW="full" ratio={1.86}>
          <Image src={featuredImage} alt={title} fallback={<Skeleton w="full" h="full" />} />
        </AspectRatio>
      </Box>
    </Box>
  );
};

export const CaseStudyHeaderFallback: FC<SkeletonOptions> = (props) => {
  const theme = useTheme();
  const { bleed } = theme.components.Container;

  return (
    <Box {...props}>
      <SkeletonText
        skeletonHeight={['2.25rem', null, '3rem', '3.75rem']}
        maxW={[null, null, null, '794px']}
        noOfLines={3}
        mx="auto"
        mt={[8, null, 10, 16]}
        mb={[10, null, 12, 20]}
      />

      <Box mx={[`-${bleed.sm}`, null, null, 'auto']} maxW={[null, null, null, '1000px']}>
        <AspectRatio maxW="full" ratio={1.86}>
          <Skeleton w="full" h="full" />
        </AspectRatio>
      </Box>
    </Box>
  );
};
